import { CandidateLiteDto } from '../../api/role/models/CandidateDto'
import { getCandidateStatusInfo } from './candidateStatusHelper'

type Props = {
    candidate: CandidateLiteDto
}

export default function CandidateStatus({
    candidate,
}: Props): React.JSX.Element {
    const statusInfo = getCandidateStatusInfo(candidate)

    return (
        <div
            className={`border rounded-lg font-semibold text-white text-sm px-2 py-1 h-fit ${statusInfo.bgColourTailwindName}`}
        >
            {statusInfo.statusLabel}
        </div>
    )
}
